import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import { useAuthStore } from '@/stores/auth';
import { isDevOrLocalAdmin, isMarketingPath } from '@/utils/adminEnv';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            redirect: '/auth/login'
        },
        MainRoutes,
        AuthRoutes,
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@/views/authentication/Error.vue')
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/404'];
    const auth: any = useAuthStore();

    if (isMarketingPath(to.path) && !isDevOrLocalAdmin()) {
        return next('/main/dashboards/general');
    }

    // requiresAuth가 있는 라우트에 접근할 때
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!auth.user) {
            auth.returnUrl = to.fullPath;
            return next('/auth/login');
        } else {
            next();
        }
    } 
    // 로그인 페이지에 접근할 때 이미 로그인되어 있으면 메인으로 리다이렉트
    else if (to.path === '/auth/login' && auth.user) {
        next('/main/dashboards/general');
    } 
    else {
        next();
    }
});

